import AddIcon from '@mui/icons-material/Add';
import ClearIcon from '@mui/icons-material/Clear';
import { Box, Button, Stack, TextField } from '@mui/material';
import { MuiFileUploader } from 'common/ui/file-uploader/MuiFileUploader';
import { useController, useForm } from 'react-hook-form';
import { ProductId, ProductPostAsset } from 'store/api/pages-api/pages-api-types';

import { styles } from './product-post-creator.styles';

type Props = {
  currentProductId: ProductId;
  onAddButton?: (data: ProductPostAsset) => void;
  onDeleteButton?: () => void;
};

const ProductPostCreator = ({ currentProductId, onAddButton }: Props) => {
  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue,
  } = useForm<ProductPostAsset>({
    defaultValues: {
      assets_type: 'blogs',
      type: 'added',
    },
  });

  const clearForm = () => {
    setValue('file_data.text', '');
    setValue('file', null);
    setValue('product_id', '');
    setValue('preview', null);
  };

  const fileField = useController({
    control,
    name: 'file',
    rules: { required: 'File is required' },
  });
  const textField = useController({ control, name: 'file_data.text' });

  const onSubmit = (data: ProductPostAsset) => {
    data.product_id = currentProductId;

    if (onAddButton) onAddButton(data);

    clearForm();
  };

  return (
    <Stack spacing={1.5} sx={styles.stack}>
        <Box sx={styles.fileUploaderWrapper}>
          <MuiFileUploader
            error={errors?.file?.message}
            format={['image/jpeg', 'image/png', 'image/svg', 'image/jpg']}
            onChange={(file, preview) => {
              fileField.field.onChange(file);
              setValue('preview', preview);
            }}
            value={fileField.field.value}
          />
        </Box>

        <TextField
          fullWidth
          label="Text"
          multiline
          placeholder="Enter your simple wording"
          size="small"
          sx={styles.textField}
          {...textField.field}
          error={textField.fieldState.invalid}
          helperText={textField.fieldState.error?.message}
        />

        <Box sx={styles.actions}>
          <Button
            onClick={handleSubmit(onSubmit)}
            size="small"
            startIcon={<AddIcon />}
            type="button"
            variant="contained"
          >
            Add
          </Button>
          <Button
            color="inherit"
            onClick={clearForm}
            size="small"
            startIcon={<ClearIcon />}
            type="button"
            variant="outlined"
          >
            Clear
          </Button>
        </Box>
      </Stack>
  );
};
export { ProductPostCreator };
